import { stringify } from 'query-string';

export default function getCustomListUrl(args: {
  listId: string;
  expand?: string;
}): string {
  const { listId, expand } = args;

  const params = stringify({
    expand,
  });

  return `/api/customEntityLists/${listId}?${params}`;
}
